import { create } from 'zustand';

const useExploreStore = create((set) => ({
  currentQuery: '',
  results: [],
  history: [],
  showStarterPanel: true,
  setCurrentQuery: (query) => set({ currentQuery: query }),
  setResults: (results) => set({ results }),
  addToHistory: (entry) => set((state) => ({ history: [entry, ...state.history] })), // Store full entry
  removeFromHistory: (index) => set((state) => {
    const newHistory = [...state.history];
    newHistory.splice(index, 1); // Remove the item at the specified index
    return { history: newHistory };
  }),
  setShowStarterPanel: (show) => set({ showStarterPanel: show }),
}));

export default useExploreStore;
